<template>
  <footer class="site-footer">

    <div class="footer-links">
      <div class="content-max-width flex">

        <div class="col">
          <h3><a href="/products">Gree Heat Pumps</a></h3>
          <ul>
            <li v-for="(link, index) of products" :key="index">
              <a :href="'/products/show/' + link.slug">{{ link.title }}</a>
            </li>
          </ul>
        </div>

        <div class="col">
          <h3 class="mobile"><a href="/warranty">Warranty</a></h3>
          <h3 class="mobile"><a href="http://support.gree.com" target="_blank">Error Code Search</a></h3>
          <h3><a href="/customer-support">Downloads</a></h3>
          <ul>
            <li><a href="/warranty">Warranty Information</a></li>
            <li><a href="http://support.gree.com" target="_blank">Error Code Search</a></li>
            <li><a href="/customer-support">Downloads</a></li>
          </ul>
        </div>

        <div class="col">
          <h3><a href="/about">About Gree</a></h3>
          <ul>
            <li><a href="/about">About Gree</a></li>
            <li><a href="/news">News</a></li>
            <li><a href="/where-to-buy">Where to buy</a></li>
            <li><a href="https://www.youtube.com/@GAS-2024" target="_blank">Gree Academy</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        <div class="col">
          <h3><a href="/contact">Contact</a></h3>
          <ul>
            <li v-if="(phone != null)"><a :href="'tel:' + phone.replace(/ /g, '')">{{ phone }}</a></li>
            <li><a :href="'mailto:' + email_to">{{ email_to }}</a></li>
          </ul>
        </div>

        <div class="col last">
          <a href="/where-to-buy" class="button">WHERE TO BUY</a>
          <a :href="'tel:' + phone.replace(/ /g, '')" class="link mobile phone-mobile" target="_blank"> {{ phone }}</a>
          <a :href="ultimate_degrees" class="link" target="_blank">ULTIMATE DEGREES <img src="/images/icon-target.svg" alt="Gree Online"></a>
        </div>

      </div>
    </div>

    <div class="footer-legal">
      <div class="content-max-width flex flex-between align-center">

        <div class="left">
          <div class="policies">
              <a href="/terms-of-use">Terms of Use</a>
              <a href="/privacy-and-cookies">Privacy and Cookies</a>

          </div>
          <p>&copy; {{ year }} Gree. All rights reserved</p>
          <!--<a
              href="http://www.brownpaperbag.co.nz/"
              target="_blank"
              class="attribution"
              >web design by { brownpaperbag }</a>-->
        </div>

        <div class="social">
          <a
              v-for="link of social"
              :href="link.url"
              >
            <a v-if="link.title === 'youtube'" :href="link.url" class="icon icon-youtube-play" target="_blank"></a>
            <a v-if="link.title === 'facebook'" :href="link.url" class="icon icon-facebook" target="_blank"></a>
            <a v-if="link.title === 'instagram'" :href="link.url" class="icon icon-instagram2" target="_blank"></a>
            <a v-if="link.title === 'linkedin'" :href="link.url" class="icon icon-linkedin" target="_blank"></a>
          </a>
        </div>

      </div>
    </div>

  </footer>
</template>

<script>
  export default {
      props: {
          pumps: Array,
          social: Array,
          phone: String,
          email_to: String,
          products: Array,
          ultimate_degrees: String
      },
      computed: {
          year () {
              return (new Date()).getFullYear()
          },
      },

  };
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue